import type { ICalendarPlusSettings } from '.';

export const DEFAULT_FORMATS = {
	date: 'MM/dd/yyyy',
	month: 'MMMM dd',
	time: 'hh:mm a',
};

export const DEFAULT_CALENDAR_VIEW = 'month';

export const BREAK_POINTS = {
	mobile: 600,
};

export const LAYOUT_ALGORITHM = {
	OVERLAP: 'overlap',
	NO_OVERLAP: 'no-overlap',
	MIXED: 'mixed',
};

const defaultThemeColors = {
	calendarBackgroundColor: '#ffffff',
	calendarTextColor: '#2D3539',
	calendarToolbarBackgroundColor: '#ffffff',
	calendarTodayCellBackgroundColor: '#eaf6ff',
	calendarSelectedCellBackgroundColor: '#f7f7f7',
	calendarPlaceholderCellBackgroundColor: '#ffffff',
	calendarBordersColor: '#dddddd',
	calendarButtonsColor: '#2B7CD4',
	eventColor: '#32C0CD',
	eventTextColor: '#FFFFFF',
	eventTooltipColor: '#6c6685',
	eventTooltipTextColor: '#FFFFFF',
	eventModalBannerColor: '#4cc2e6',
	eventModalBackgroundColor: '#ffffff',
	eventModalCardsColor: '#F1F3F4',
	filtersBackgroundColor: '#ffffff',
	filtersTextColor: '#2D3539',
};

export const defaultCalendarSettings = {
	monthView: true,
	weekView: true,
	dayView: true,
	agendaView: true,
	enableCalendarFilters: true,
	defaultView: '',
	backButtonLabel: 'Back',
	nextButtonLabel: 'Next',
	todayButtonLabel: 'Today',
	monthButtonLabel: 'Month',
	weekButtonLabel: 'Week',
	dayButtonLabel: 'Day',
	agendaButtonLabel: 'Agenda',
	timeLabel: 'Time',
	locationLabel: 'Location',
	eventDetailLabel: 'Event Details',
	showMoreLabel: 'Show More',
	registerEventButtonLabel: 'Register',
	dateFormat: '',
	timeFormat: '',
	monthFormat: '',
	customDateFormat: '',
	customTimeFormat: '',
	customMonthFormat: '',
	formats: {
		monthFormat: DEFAULT_FORMATS.month,
		dateFormat: DEFAULT_FORMATS.date,
		timeFormat: DEFAULT_FORMATS.time,
	},
	showTooltip: true,
	styles: {
		light: defaultThemeColors,
		dark: defaultThemeColors,
	},
	layoutAlgorithm: 'no-overlap',
	enableFeaturedImage: false,
	tagColorScheme: 'blue',
	tagVariant: 'solid',
	categoryColorScheme: 'gray',
	categoryVariant: 'solid',
	radius: {
		toolbar: 'none',
		calendarView: 'none',
	},
} as ICalendarPlusSettings;

export const WEEK_DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

export const RADIUS = {
	xs: '1px',
	sm: '2px',
	md: '4px',
	lg: '8px',
	xl: '12px',
	'2xl': '16px',
	'3xl': '32px',
};
